import { render, staticRenderFns } from "./CertificateList.vue?vue&type=template&id=3ee9c20c&scoped=true&"
import script from "./CertificateList.vue?vue&type=script&lang=js&"
export * from "./CertificateList.vue?vue&type=script&lang=js&"
import style0 from "./CertificateList.vue?vue&type=style&index=0&id=3ee9c20c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee9c20c",
  null
  
)

export default component.exports